export default __webpack_public_path__ + "b896b8d3133bf44c0c356cd337171e8a.png";